import { render, staticRenderFns } from "./CscContractsPage.vue?vue&type=template&id=87aa2cc0&"
import script from "./CscContractsPage.vue?vue&type=script&lang=js&"
export * from "./CscContractsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports